import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 6.5H6.22437V8.50391H8.22827V6.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 13H18.9763C16.0768 13 13.7263 15.3505 13.7263 18.25C13.7263 19.719 14.3297 21.0471 15.3021 22H2.22632V13ZM8.22827 15.5H6.22437V17.5039H8.22827V15.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.9763 14.5C16.9053 14.5 15.2263 16.1789 15.2263 18.25C15.2263 20.3211 16.9053 22 18.9763 22C19.6487 22 20.2797 21.8231 20.8253 21.5132L22.4763 23.1642L23.8905 21.75L22.2395 20.099C22.5494 19.5533 22.7263 18.9223 22.7263 18.25C22.7263 16.1789 21.0474 14.5 18.9763 14.5ZM17.2263 18.25C17.2263 17.2835 18.0098 16.5 18.9763 16.5C19.9428 16.5 20.7263 17.2835 20.7263 18.25C20.7263 19.2165 19.9428 20 18.9763 20C18.0098 20 17.2263 19.2165 17.2263 18.25Z"}}]};

const DataSearchFilled = Vue.extend<IconProps>({
  name: 'DataSearchFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'data-search-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DataSearchFilled;
